import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { UserKpiCard } from "./UserKpiCard";

export interface EmployeeProfileKpiItem {
  label: string;
  value: string;
  detail: string;
  icon: LucideIcon;
  tone?: "neutral" | "gold" | "danger" | "success";
}

interface EmployeeProfileKpisProps {
  items: EmployeeProfileKpiItem[];
  // The admin employee-detail page renders this full-width (up to 4 per
  // row); /profile's two-column layout gives it a narrower container, where
  // the viewport-based xl:grid-cols-4 breakpoint would cram 4 cards into a
  // half-width column — cap it at 2 there.
  maxColumns?: 2 | 4;
}

// Shared KPI strip: the admin employee-detail page uses 4 cards, /profile's
// self-summary uses fewer — same card, same grid, different item count.
export function EmployeeProfileKpis({ items, maxColumns = 4 }: EmployeeProfileKpisProps) {
  return (
    <div
      className={cn(
        "grid grid-cols-1 gap-3 sm:grid-cols-2",
        maxColumns === 4 && "xl:grid-cols-4",
      )}
    >
      {items.map((item) => (
        <UserKpiCard key={item.label} {...item} />
      ))}
    </div>
  );
}
